import { useSyncExternalStore } from "react";

import { pwaInstallStore } from "./pwaInstallStore";

export function usePwaInstall() {
  const canInstall = useSyncExternalStore(pwaInstallStore.subscribe, pwaInstallStore.canInstall, () => false);
  return { canInstall, install: pwaInstallStore.promptInstall };
}
